import { render } from "./ProductModals.vue?vue&type=template&id=bf99e7a4"
import script from "./ProductModals.vue?vue&type=script&lang=js"
export * from "./ProductModals.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hi5admin_demo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__